<template>
  <Dialog
    :visible="visible"
    :title="$t(`${namespace}.deleteEmployee`)"
    :isLoading="isLoading"
    @close="close()"
  >
    <div>
      <v-card-text v-if="isValidObject(item)" class="dialog__body">
        <span v-html="$t(`${namespace}.areYouSureDesc`).replace('[VAL]', item.name)" />
      </v-card-text>

      <v-card-actions class="dialog__footer">
        <v-spacer/>

        <a
          v-if="!isLoading"
          class="mr-4"
          @click.prevent="close()"
        >
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <Button
          :loading="isLoading"
          :disabled="isLoading"
          @click="deleteEmployee"
        >
          {{ $t(`${namespace}.deleteEmployee`) }}
        </Button>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'SingleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage.singleDeleteDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isValidObject(val)
    },

    close (reload = false) {
      this.$emit('close', reload)
    },

    setLoadingValue (boolean) {
      this.isLoading = boolean
    },

    async deleteEmployee () {
      this.setLoadingValue(true)

      try {
        await this.$apiService.employee.delete(this.item.id)

        this.close(true)
        this.showAlert({
          type: 'success',
          message: `${this.$t(`${this.namespace}.success`).replace('[VAL]', this.item.name)}`
        })
      } catch (error) {
        const message = error?.response?.data?.errors
          ? error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]
          : this.$t(`${this.namespace}.error`)

        this.showAlert({ type: 'error', message })
        catchError(error)
      }

      this.setLoadingValue(false)
    }
  }
}
</script>
